import EFPicture from 'elem/compCommon/EFPicture';
import { useGlobal } from '@/utils/useGlobal';

export default function D() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_220w_double');
    return (
        <div className="sp-220-double-D">
            <div className="info-box">
                <p className="title">{t('D_title')}</p>
                <p className="desc">{t('D_desc')}</p>
            </div>
            <div className="img-box">
                <EFPicture
                    src="/responsive/picture/solar-panel-220w-double/4.jpg"
                    srcPad="/responsive/picture/solar-panel-220w-double/4_768.jpg"
                    srcMobile="/responsive/picture/solar-panel-220w-double/4_768.jpg"
                    alt={t('D_title')}
                />
            </div>
        </div>
    );
}
